import React from 'react'
import Accordion from '@mui/material/Accordion';
import AccordionDetails from '@mui/material/AccordionDetails';
import AccordionSummary from '@mui/material/AccordionSummary';
import Typography from '@mui/material/Typography';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import SummarizeIcon from '@mui/icons-material/Summarize';

const Reporting = () => {
    const [expanded, setExpanded] = React.useState(false);

    const handleChange = (panel) => (event, isExpanded) => {
        setExpanded(isExpanded ? panel : false);
    };
    return (
        <>
            <div style={{ width: '80%', display: 'flex', margin:'auto', marginTop:'2rem', marginBottom:'1rem'}}>
                <SummarizeIcon style={{ color: '#10609e' }}/>
                <p style={{ width: '80%', marginTop: '3px', marginLeft:'1rem', fontWeight:'bold', color:'#10609e'  }}>Reporting and Uploading the collected data:</p><br />
            </div>
            <Accordion className='accordian_members' expanded={expanded === 'panel11'} onChange={handleChange('panel11')} style={{ width: '80%', marginLeft: 'auto', marginRight: 'auto' }}>
                <AccordionSummary
                    expandIcon={<ExpandMoreIcon />}
                    aria-controls="panel4bh-content"
                    id="panel4bh-header"
                >
                    <Typography className='typo_heading' sx={{ width: '85%', flexShrink: 0 }}>What is the "SUNRISEChecklist spreadsheet”?</Typography>
                </AccordionSummary>
                <AccordionDetails>
                    <Typography >
                        <ul style={{ listStyleType: 'none' }}>
                            <li>Within your country's CloudStor folder, you'll find a file named "SUNRISEChecklist spreadsheet" with 3 tabs.</li><br />
                            <ol style={{ marginLeft: '2rem' }}>
                                <li data-text="Child ID and Assessment Checklist: ">Data collectors should use this tab to list the Child IDs they are collecting data from and to track
                                    completed/uploaded assessments for each participating child.</li>
                                <li data-text="Centre-specific Data Checklist: ">This tab is used to record completed and uploaded centre-specific data to REDCap.</li>
                                <li data-text="Response Rates for Data Collection: ">The Data Collection team completes this tab to track response rates for rural and urban data collection.
                                    It includes the number of eligible children within the age range of 3.0 to 4.9 who can wear an accelerometer, the number of children who
                                    consented, and reasons for participation or decline. It also tracks the number of contacted centres and reasons for decline, if applicable.</li>
                            </ol><br />
                            <li>This spreadsheet is crucial for tracking data collection progress, informing the UOW Coordinating Centre about collected data, and assessing successful data uploading for each country.</li>
                        </ul>
                    </Typography>
                </AccordionDetails>
            </Accordion>
            <Accordion className='accordian_members' expanded={expanded === 'panel12'} onChange={handleChange('panel12')} style={{ width: '80%', marginLeft: 'auto', marginRight: 'auto' }}>
                <AccordionSummary
                    expandIcon={<ExpandMoreIcon />}
                    aria-controls="panel4bh-content"
                    id="panel4bh-header"
                >
                    <Typography className='typo_heading' sx={{ width: '85%', flexShrink: 0 }}>How often do I complete the "SUNRISEChecklist spreadsheet” in CloudStor?</Typography>
                </AccordionSummary>
                <AccordionDetails>
                    <Typography >
                        <ul style={{ listStyleType: 'none' }}>
                            <li>We recommend updating ‘Child ID and Assessment Checklist tab’ on this spreadsheet at least once a week, or more frequently if possible. The UOW
                                Coordinating Centre will also update it regularly to confirm the received data from your team. We aim to update this spreadsheet weekly also.</li><br />
                            <li>The ‘Centre-specific Data Checklist’ and ‘Response Rates’ tabs should be completed each time data collection is finished within a centre.</li>
                        </ul>
                    </Typography>
                </AccordionDetails>
            </Accordion>
            <Accordion className='accordian_members' expanded={expanded === 'panel13'} onChange={handleChange('panel13')} style={{ width: '80%', marginLeft: 'auto', marginRight: 'auto' }}>
                <AccordionSummary
                    expandIcon={<ExpandMoreIcon />}
                    aria-controls="panel4bh-content"
                    id="panel4bh-header"
                >
                    <Typography className='typo_heading' sx={{ width: '85%', flexShrink: 0 }}>How often should I sync the data in REDCap and the EYToolbox?</Typography>
                </AccordionSummary>
                <AccordionDetails>
                    <Typography >
                        To minimize the risk of data loss, it is recommended to sync the data from the iPads (including REDCap and both EYToolbox games) at least once a week, or
                        ideally multiple times a week if feasible. Before syncing the data, ensure that the iPads are connected to the internet and that the internet connection is
                        strong. It is important to sync each iPad application individually, one at a time.
                    </Typography>
                </AccordionDetails>
            </Accordion>
            <Accordion className='accordian_members' expanded={expanded === 'panel14'} onChange={handleChange('panel14')} style={{ width: '80%', marginLeft: 'auto', marginRight: 'auto' }}>
                <AccordionSummary
                    expandIcon={<ExpandMoreIcon />}
                    aria-controls="panel4bh-content"
                    id="panel4bh-header"
                >
                    <Typography className='typo_heading' sx={{ width: '85%', flexShrink: 0 }}>How do I sync the EYToolbox data?</Typography>
                </AccordionSummary>
                <AccordionDetails>
                    <Typography >
                        <ul style={{ listStyleType: 'none' }}>
                            <li>The steps to submit data are:</li><br />
                            <ol style={{ marginLeft: '2rem' }}>
                                <li>Quickly double tap the iPad home button and swipe the apps up off the screen to close them.</li>
                                <li>Connect the iPad to the internet.</li>
                                <li>Re-open each of the apps, one by one, leaving them on the screen for a minute so the data can send to the database.</li>
                            </ol>
                        </ul>
                    </Typography>
                </AccordionDetails>
            </Accordion>
            <Accordion className='accordian_members' expanded={expanded === 'panel15'} onChange={handleChange('panel15')} style={{ width: '80%', marginLeft: 'auto', marginRight: 'auto' }}>
                <AccordionSummary
                    expandIcon={<ExpandMoreIcon />}
                    aria-controls="panel4bh-content"
                    id="panel4bh-header"
                >
                    <Typography className='typo_heading' sx={{ width: '85%', flexShrink: 0 }}>How do I know that the EYToolbox data has synced?</Typography>
                </AccordionSummary>
                <AccordionDetails>
                    <Typography >
                        You can check whether the data has submitted by tapping the ‘I’ menu in the bottom right corner of the title screen and looking at the data submission
                        timestamp at the bottom of the pop-up window. If it shows the current time and date, the data has submitted. If it does not, close that pop-up window, leave
                        the app open for another minute and check the ‘I’ menu timestamp again. This should submit all data that has been collected since the last time you submitted.
                    </Typography>
                </AccordionDetails>
            </Accordion>
        </>
    )
}

export default Reporting
